export const capitalize = (string: string | null | undefined): string | null => {
  if (!string || typeof string !== 'string') {
    return null
  }
  return string.charAt(0).toUpperCase() + string.slice(1)
}

export const snakeToCamel = (string: string): string => {
  return string.replace(/_([a-z])/g, (_, letter) => letter.toUpperCase())
}
